import { CONSORS_GENDERS } from 'cpool-constants';
import { z } from 'zod';

export const schemaConsorsGender = z.nativeEnum(CONSORS_GENDERS);
export type SchemaConsorsGender = z.infer<typeof schemaConsorsGender>;
